<template>
  <div class="card-actions">
    <CustomTooltip
      v-if="isAllowedClipboard ? isAllowedClipboard() : true"
      :message="$t('legal_assistant.actions.copy')"
      position="bottom"
      size="small"
    >
      <AppIcon
        name="copy-text"
        size="body-xl"
        class-name="color-lighter"
        :onClick="handleOnClickCopyButton"
        :clickable="true"
      />
    </CustomTooltip>
    <CustomTooltip
      :message="$t('legal_assistant.actions.insert')"
      position="bottom"
      size="small"
    >
      <AppIcon
        name="insert-text"
        size="body-xl"
        class-name="color-lighter"
        :onClick="handleOnClickInsertButton"
        :clickable="true"
      />
    </CustomTooltip>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';

defineProps<{ isAllowedClipboard?: () => boolean }>();

const emit = defineEmits<{ (e: 'action', action: 'copy' | 'insert'): void }>();
const handleOnClickCopyButton = () => emit('action', 'copy');
const handleOnClickInsertButton = () => emit('action', 'insert');
</script>

<style scoped lang="scss">
.card-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: $space-3;
  gap: $space-3;
}
</style>
